module.exports = __webpack_public_path__ + "img/Zhaosheng.be7bec53.png";